export function toFixed(num) {
  const d = Number(num);
  return Number(d.toFixed(2));
}

export function numberFormat(val) {
  if (!val) return '0.00';
  const baseInt = Number(val);

  const intPart = baseInt > 0 ? Math.floor(baseInt) : Math.ceil(baseInt);

  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

  let floatPart = '.00';

  const value2Array = val.toString().split('.');

  let result;

  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString().slice(0, 2);

    if (floatPart.length === 1) {
      result = intPartFormat + '.' + floatPart + '0';
    } else {
      result = intPartFormat + '.' + floatPart;
    }
  } else {
    result = intPartFormat + floatPart;
  }

  if (baseInt > -1 && baseInt < 0) return `-${result}`;
  else return result;
}

export function currencyAmount(value) {
  if (value === '-') {
    return value;
  }
  const x = Math.floor(Number(value) * 100) / 100;

  const y = (Math.floor(Number(value * -1.0) * 100) / 100) * -1.0;
  if (value < 0.0) {
    return String(y).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }
  return String(x).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

export function currencySymbol(type) {
  switch (type) {
    case '003':
      return '¥';
    case 'usd':
      return '$';
    case '001':
      return '$';
    case 'jpy':
      return '¥';
    case '002':
      return '¥';
    case 'cny':
      return '元';
    default:
      return '$';
  }
}
